export const GET_UPLOAD_DATA = 'GET_UPLOAD_DATA'
